import * as React from 'react';

import { Button, Typography } from 'omakase';

import Anchor from 'components/Anchor';

interface Props {
  domainName: string;
}

const PrivateDiningRequest: React.FunctionComponent<Props> = ({ domainName }) => {
  return (
    <section className="PrivateDiningRequest">
      <Typography component="h2" variant="heading04" mb={1}>
        Private Events
      </Typography>
      <Typography variant="body02" component="p" mb={3}>
        If you are interested in learning more about our offerings, please fill out the request form
        and we will contact you to discuss details.
      </Typography>

      <Button
        variant="primary"
        component={Anchor}
        aria-label="Request information (opens a dialog)"
        href={`/${domainName}/private-dining`}
        size="medium"
      >
        Request information
      </Button>
    </section>
  );
};

export default PrivateDiningRequest;
